
import styled from 'styled-components';

export const SLabel = styled.label`
    display:block;
    font-size: .75rem;
`;
export const BULK = 'bulk';
export const SINGLE = 'single';
export const COMBINED = 'combine';
export const invoiceType = [{
    label: 'Final',
    name: 'invoiceType',
    value: 'final',
}, {
    label: 'Draft',
    name: 'invoiceType',
    value: 'draft'
}]
export const communicationType = [{
    label: 'Printer',
    name: 'communicationType',
    value: 'printer',
    isDisabled: false

}, {
    label: 'Email',
    name: 'communicationType',
    value: 'email',
    isDisabled: false
}]
export const InvoiceText = 'Please choose charge items from the selected Document to invoice'
export const InvoiceTextFCR = 'Please choose charge items from the selected FCR to invoice'
export const InvoiceETSText = 'Please choose charge items from the selected ETS to invoice'
export const BulkButton = 'ISSUE BULK INVOICE';
export const InvoiceButton = 'ISSUE INVOICE';